// TODO move this to share-module
const slugOptions = {
  replacement: "_", // replace spaces with replacement character, defaults to `-`
  lower: true, // convert to lower case, defaults to `false`
  strict: true, // strip special characters except replacement, defaults to `false`
};

export {slugOptions};
